import React from 'react';
import Heading from "../../../../../../../components/Heading";
import BackButton from "../../../../../../../components/BackButton";
import BuildingUser from "../../../../../../../styles/svg/building-user.svg";

const DetailHeader = ({ title }) => {
  return (
    <Heading title={title} icon={BuildingUser}>
      <BackButton/>
    </Heading>
  );
};

export default DetailHeader; 